/* global axios */
import ApiClient from '../ApiClient';

class InternalChatMessages extends ApiClient {
  constructor() {
    super('internal_chat_conversations', { accountScoped: true });
  }

  get(conversationId, before) {
    return axios.get(`${this.url}/${conversationId}/messages`, {
      params: before ? { before } : {},
    });
  }

  create(conversationId, { content, contentType, files }) {
    if (files && files.length) {
      const formData = new FormData();
      if (content) {
        formData.append('content', content);
      }
      if (contentType) {
        formData.append('content_type', contentType);
      }
      files.forEach(file => formData.append('files[]', file));
      return axios.post(`${this.url}/${conversationId}/messages`, formData);
    }

    return axios.post(`${this.url}/${conversationId}/messages`, {
      content,
      content_type: contentType,
    });
  }
}

export default new InternalChatMessages();
